import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DrawerHeader = ({ title, subtitle, onClose }) => {
    return (
      <Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start',
						padding: '16px 18px 14px',
						borderBottom: '0.5px solid',
						borderColor: 'border.light',
						flexShrink: 0,
    				}}              
				>
					<Box>
						<Typography sx={{ fontSize: '14px', fontWeight: 700 }}>
							{title}
						</Typography>

						{subtitle && (
							<Typography
								sx={{ fontSize: '12px', color: 'text.secondary', mt: '2px' }}
							>
								{subtitle}
							</Typography>
						)}
					</Box>

					{/* Close button */}
					<IconButton
						data-testid='alert-drawer-close-button'
						size='small'
						onClick={onClose}
					>
						<CloseIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Box>
    );
};

DrawerHeader.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    subtitle: PropTypes.string,
};

export default DrawerHeader;